import React from 'react';

import InputFieldComponent from './InputFieldComponent';

class TextInputFieldComponent extends React.Component {
    render() {
        return <InputFieldComponent {...this.props} type="text" />;
    }
}

// See proptypes in ./InputFieldComponent.js

export default TextInputFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/TextInputFieldComponent.js